import React from 'react';
import Header from '../../Components/Header';
import VisaSearch from './VisaSearch';


const Visa = () => (
  <>
  <Header></Header>
   <section className='Visa_top_banner'>
      <VisaSearch />
    </section>
    <section class="footer_top"> 
		<div class="container">
		<div class="_toprflcont mb-8">
			<div class="_hdrtxt">Quick Links </div>
		</div>
     <div class="col-md-12">
        <div class="d-flex-bus">
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/US.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>US visa</h5>
                </a>
            </div>
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/UK.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>UK Visa</h5>
                </a>
            </div>
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/Schengen.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>Schengen Visa</h5>
                </a>
            </div>
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/Singapore.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>Singapore Visa</h5>
                </a>
            </div>
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/UAE.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>UAE Visa</h5>
                </a>
            </div>
           
           
        </div>
     </div>
           
            
        </div>    
    </section>
  </>
   
);

export default Visa;
